import Axios from 'axios';
import env from 'env';

export default Axios.create({
  baseURL: `${env.SERVER_ENDPOINT}/`,
});
